module.exports = __webpack_public_path__ + "img/exc_4.b0bc1e6a.webp";